import { createContext, useContext, useState } from 'react'
import { useUtiles } from './utilesContext'
import moment from 'moment-timezone'
import axios from 'axios'
import { Config } from '../services/config'
import Swal from 'sweetalert2'
import { TaskService } from '../services/taskService'
import { useNavigate } from 'react-router'
import { otService } from '../services/otService'
import { useOt } from './otContext'
import dayjs from 'dayjs'

const TaskContext = createContext()

export const useTaskContext = () => useContext(TaskContext)

// Función auxiliar para obtener la fecha en formato datetime-local con zona horaria de Perú
const getPeruDateTime = (date = new Date()) => {
    return moment(date).tz('America/Lima').format('YYYY-MM-DDTHH:mm');
}

export const TaskProvider = ({ children }) => {

    const { getOtCalculateCompleted, ot, getOtByHash } = useOt()

    const [valueOtReview, setValueOtReview] = useState(0)

    const [stepActive, setStepActive] = useState(1)

    const navigate = useNavigate()


    const handleStep = (step) => {
        setStepActive((prev) => prev + 1)
    }

    const handleStepBack = () => {
        setStepActive((prev) => prev - 1)
    }






    const { priorityOptions, resetOpenSilder, setAlertSnackbar } = useUtiles()
    const [task, setTask] = useState({
        asset: null,
        assigned_to: null,
        extra_technical_support: [],
        date_of_incident: getPeruDateTime(),
        requested_by: "",
        description: "",
        note: "",
        typeTask: null,
        classification_1: "",
        classification_2: "",
        priority: "Media",
        time_duration: "000:10", // minutos
        datetime_start_estimated: getPeruDateTime(), //formato yyyy-MM-ddThh:mm
        datetime_start: getPeruDateTime(), //formato yyyy-MM-ddThh:mm
        datetime_end: getPeruDateTime(moment().add(10, 'minutes').toDate()), //formato yyyy-MM-ddThh:mm
        status: "pendiente",
        time_execution: "000:10",
        required_ssoma: false,
        ssoma_code_document: "",
        ssoma_validate: false,
        ssoma_hash_code: "",
    })




    const [conditions, setConditions] = useState({
        task_realized: false,
        send_to: "pending",

    })

    const [subtaskList, setSubtaskList] = useState([
        {
            code: "",
            order: 1,
            description: "Subtarea 1",
            type_field: "text",
            is_mandatory: true,
        },

    ])
    const [subtask, setSubtask] = useState({
        code: "",
        order: 1,
        description: "",
        type_field: "",
        is_mandatory: false,
        //require_attachment: false,
        options: [{
            value: "Opcion 1",
        }, {
            value: "Opcion 2",
        }, {
            value: "Opcion 3",
        }],
    })

    //resource
    const [resourceList, setResourceList] = useState([])

    const [isNew, setIsNew] = useState(false)

    const [resource, setResource] = useState({
        id: null,
        code: "",
        quantity: 0,
        unit: "",
        location: "",
        is_new: false,
        name_new: "",
    })



    //TODOS LOS RESETS
    const resetResource = () => {
        setResource({
            id: null,
            code: "",
            quantity: 0,
            unit: "",
            location: "",
            is_new: false,
            name_new: "",
        })
    }



    const resetConditions = () => {
        setConditions({
            task_realized: false,
            send_to: "pending",
        })
    }

    const resetSubtaskList = () => {
        setSubtaskList([
            {
                code: "",
                order: 1,
                description: "Subtarea 1",
                type_field: "text",
                is_mandatory: true,
            },

        ])
    }


    const resetSubtaskResponse = () => {
        setSubtaskResponse([])
    }



    const resetTask = () => {
        setStepActive(1)
        resetResource()
        resetConditions()
        resetSubtaskList()
        resetSubtaskResponse()
        setResourceList([])
        setConditions({
            task_realized: false,
            send_to: "pending",
        })
        setSubtaskList([
            {
                code: "",
                order: 1,
                description: "Subtarea 1",
                type_field: "text",
                is_mandatory: true,
            },
        ])
        setSubtaskResponse([])
        setTask({
            asset: null,
            assigned_to: null,
            extra_technical_support: [],
            date_of_incident: getPeruDateTime(),
            requested_by: "",
            description: "",
            note: "",
            typeTask: null,
            classification_1: "",
            classification_2: "",
            priority: "Media",
            time_duration: "000:10", // minutos 
            datetime_start_estimated: getPeruDateTime(), //formato yyyy-MM-ddThh:mm
            datetime_start: getPeruDateTime(), //formato yyyy-MM-ddThh:mm
            datetime_end: getPeruDateTime(moment().add(10, 'minutes').toDate()), //formato yyyy-MM-ddThh:mm
            status: "pendiente",
            time_execution: "000:10",
            required_ssoma: false,
            ssoma_code_document: "",
        })
    }


    /** ESTOS METODOS SERAN ELIMINADOS LUEGO DE LA REVISION DE INSUMOS */
    const [isUpdateResource, setIsUpdateResource] = useState(false)
    const handleEditResource = (index) => {
        const isNewResource = resourceList[index].code === ""
        setResource(resourceList[index])
        setIsUpdateResource(true)
        setIsNew(isNewResource)
    }

    const handleDeleteResource = async (index) => {
        const confirm = await Swal.fire({
            title: '¿Está seguro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        })
        if (confirm.isConfirmed) {
            const newResourceList = [...resourceList]
            newResourceList.splice(index, 1)
            setResourceList(newResourceList)
        }
    }


    const handleSaveResource = async () => {
        if (isUpdateResource) {
            const newResourceList = [...resourceList]
            const indexResource = resourceList.findIndex(el => el.code === resource.code)
            newResourceList[indexResource] = resource
            setResourceList(newResourceList)
        } else {

            const existResource = resourceList.find(el => el.code === resource.code)

            if (existResource && !isNew) {
                //Notificar que ya existe el codigo y se sumara la cantidad
                const alert = await Swal.fire({
                    title: '¿Ya existe el insumo, desea sumar la cantidad?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    customClass: {
                        container: 'custom-swal2-container',
                        popup: 'custom-swal2-popup',
                        backdrop: 'custom-swal2-backdrop',
                    }
                })
                if (alert.isConfirmed) {
                    //sumar la cantidad
                    const newResource = { ...existResource }
                    newResource.quantity = parseInt(newResource.quantity) + parseInt(resource.quantity)
                    const indexResource = resourceList.findIndex(el => el.code === resource.code)
                    const newResourceList = [...resourceList]
                    newResourceList[indexResource] = newResource
                    setResourceList(newResourceList)
                }
            } else {
                //si no existe el codigo, se crea un nuevo recurso
                setResourceList([...resourceList, resource])
            }
        }
        resetResource()
        resetOpenSilder()
        setIsUpdateResource(false)
        setIsNew(false)
    }

    /** ESTOS METODOS SERAN ELIMINADOS LUEGO DE LA REVISION DE INSUMOS */

    //subtask

    const [indexSubtask, setIndexSubtask] = useState(null)

    const resetSubtask = () => {
        setSubtask({
            order: 1,
            description: "",
            type_field: "",
            is_mandatory: false,
            //require_attachment: false,
            options: [{
                value: "Opcion 1",
            }, {
                value: "Opcion 2",
            }, {
                value: "Opcion 3",
            }],
        })
    }

    const [subtaskValue, setSubtaskValue] = useState({
        value: "",
    })

    const [subtaskResponse, setSubtaskResponse] = useState([])




    //validar documento de ssoma
    const [loadingSsoma, setLoadingSsoma] = useState(false)
    const [ssomaResponse, setSsomaResponse] = useState(null)
    const validateSsomaDocument = async () => {
        const { ssoma_code_document } = task
        if (ssoma_code_document) {
            try {
                setLoadingSsoma(true)
                const response = await axios.get(`${Config.apiSsoma}/validate-register-code/`, {
                    params: {
                        code: task.ssoma_code_document
                    }
                })
                if (response.status === 200) {
                    setTask({ ...task, ssoma_validate: true, ssoma_hash_code: response.data.hash_code })
                    setSsomaResponse(response.data)
                    setLoadingSsoma(false)
                }
            } catch (error) {
                console.log(error)
                setLoadingSsoma(false)
            }
        }
    }


    //Obtener documento de ssoma por hash (Usado para el detalle de la OT)
    const [loadingSsomaDocument, setLoadingSsomaDocument] = useState(false)
    const [ssomaDocument, setSsomaDocument] = useState(null)
    const getSsomaDocument = async (code_document) => {
        try {
            setLoadingSsomaDocument(true)
            const response = await axios.get(`${Config.apiSsoma}/validate-register-code/`, {
                params: {
                    code: code_document
                }
            })
            setSsomaDocument(response.data)
            setLoadingSsomaDocument(false)
            return response.data
        } catch (error) {
            console.log(error)
            setLoadingSsomaDocument(false)
            setAlertSnackbar({
                open: true,
                message: error.response.data.error || "Error al obtener el documento de SSOMA",
                severity: "error"
            })
            return null
        }
    }



    const [loadingDownloadSsoma, setLoadingDownloadSsoma] = useState(false)
    const downloadSsomaDocument = async (taskDetail = false) => {
        const documentData = taskDetail ? ssomaDocument : ssomaResponse;

        if (documentData) {
            try {
                setLoadingDownloadSsoma(true)
                const response = await axios.get(`${Config.apiSsoma}/${documentData.formato_name.toLowerCase()}/${documentData.hash_code}/pdf/`, {
                    responseType: 'blob'
                })
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${documentData.formato_name || 'documento'}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setLoadingDownloadSsoma(false)
            } catch (error) {
                console.log(error)
                setLoadingDownloadSsoma(false)
            }
        }
    }


    //guardar codigo de ssoma en el task
    /*
        Se modifica la logica de estas funciones, ya que no se actualizará la información directamente en la tabla task, sino que se hará en la tabla ot_task
    */
    const saveSsomaCode = async (ssomaDocumentData, code_document, hash_code_task_param) => {
        try {
            const data = {
                ssoma_hash_code: ssomaDocumentData.hash_code,
                ssoma_code_document: code_document,
                hash_code: hash_code_task_param,
                ot_id : ot.id,
                task_id : taskByHash.id,
                task_scheduled_id : hash_code_task.task_scheduled_id
            }
            const response = await TaskService.saveSsomaCode(data)
            setAlertSnackbar({
                open: true,
                message: "Código de SSOMA guardado correctamente",
                severity: "success"
            })

            await getTaskByHash(hash_code_task_param)
            return true
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Error al guardar el código de SSOMA",
                severity: "error"
            })
            return false
        }
    }




    const resetSsomaValidate = () => {
        setTask({ ...task, ssoma_validate: false, ssoma_hash_code: "", ssoma_code_document: "" })
        setSsomaResponse(null)
    }






    //Crear tarea
    const [loadingCreateTask, setLoadingCreateTask] = useState(false)
    const createTask = async () => {
        setLoadingCreateTask(true)
        try {

            //formatear fechas usando moment para ser enviadas al backend datetime
            const datetime_start_estimated = moment(task.datetime_start_estimated).format('YYYY-MM-DD HH:mm:ss')
            const datetime_start = moment(task.datetime_start).format('YYYY-MM-DD HH:mm:ss')
            const datetime_end = moment(task.datetime_end).format('YYYY-MM-DD HH:mm:ss')
            const date_of_incident = moment(task.date_of_incident).format('YYYY-MM-DD HH:mm:ss')

            task.datetime_start_estimated = datetime_start_estimated
            task.datetime_start = datetime_start
            task.datetime_end = datetime_end
            task.date_of_incident = date_of_incident
            const data = {
                ...task,
                conditions: conditions,
                subtask_list: subtaskList,
                subtask_response: subtaskResponse,
                resource_list: resourceList,
            }
            const response = await TaskService.createTask(data)


            setAlertSnackbar({
                open: true,
                message: "Tarea creada correctamente",
                severity: "success"
            })

            resetConditions()
            //SE RESETEA DIRECTAMENTE EL OBJETO TASK
            task.description = ""
            task.note = ""
            task.typeTask = null
            task.classification_1 = ""
            task.classification_2 = ""
            task.priority = "Media"
            task.asset = null
            task.requested_by = ""
            task.assigned_to = null

            resetSubtaskList()
            setResourceList([])
            resetSsomaValidate()
            resetSubtaskResponse()
            setStepActive(1)

            navigate('/task/wo')




        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Error al crear la tarea",
                severity: "error"
            })
        } finally {
            setLoadingCreateTask(false)
        }
    }

    //ACTUALIZAR TAREA
    const [isUpdateTask, setIsUpdateTask] = useState(false)
    const [loadingUpdateTask, setLoadingUpdateTask] = useState(false)
    const updateTask = async () => {
        try {
            setLoadingUpdateTask(true)
            try {

                //formatear fechas usando moment para ser enviadas al backend datetime
                const datetime_start_estimated = moment(task.datetime_start_estimated).format('YYYY-MM-DD HH:mm:ss')
                const datetime_start = null
                const datetime_end = null
                const date_of_incident = moment(task.date_of_incident).format('YYYY-MM-DD HH:mm:ss')

                task.datetime_start_estimated = datetime_start_estimated
                task.datetime_start = datetime_start
                task.datetime_end = datetime_end
                task.date_of_incident = date_of_incident
                const data = {
                    ...task,
                    conditions: conditions,
                    subtask_list: subtaskList,
                }
                const response = await TaskService.updateTask(data)


                setAlertSnackbar({
                    open: true,
                    message: "Tarea actualizada correctamente",
                    severity: "success"
                })

                resetConditions()
                //SE RESETEA DIRECTAMENTE EL OBJETO TASK
                task.description = ""
                task.note = ""
                task.typeTask = null
                task.classification_1 = ""
                task.classification_2 = ""
                task.priority = "Media"
                task.asset = null
                task.requested_by = ""
                task.assigned_to = null

                resetSubtaskList()
                setResourceList([])
                resetSsomaValidate()
                resetSubtaskResponse()
                setStepActive(1)

                navigate('/task/wo')




            } catch (error) {
                console.log(error)
                setAlertSnackbar({
                    open: true,
                    message: error.response.data || "Error al actualizar la tarea",
                    severity: "error"
                })
            } finally {
                setLoadingUpdateTask(false)
            }
        } catch (error) {
            console.log(error)
        }
    }


    //TODAS LAS TAREAS
    const [tasks, setTasks] = useState([])
    const [loadingTasks, setLoadingTasks] = useState(false)

    const [filtersKanban, setFiltersKanban] = useState({
        startDate: null,
        endDate: null,
        responsible: null,
        description: null,
        numberOt: null,
        taskType: null,
    })

    const getTasks = async (params) => { 
        try {
            setLoadingTasks(true)
            // Convert dates to the format expected by the API using dayjs
            const filters = {
                ...params,
                startDate: params.startDate ? params.startDate.format('YYYY-MM-DD') : null,
                endDate: params.endDate ? params.endDate.format('YYYY-MM-DD') : null,
                responsible: params.responsible ? JSON.stringify(params.responsible) : null,
                description: params.description ? params.description : null,
                numberOt: params.numberOt ? params.numberOt : null,
                taskType: params.taskType ? params.taskType : null,
            }
            console.log(filters)
            const response = await TaskService.getTasks(filters)
            setTasks(response.data)
            console.log(response.data)
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Error al obtener las tareas",
                severity: "error"
            })
        } finally {
            setLoadingTasks(false)
        }
    }


    //TASKS CALENDAR
    const [tasksCalendar, setTasksCalendar] = useState([])
    const [loadingTasksCalendar, setLoadingTasksCalendar] = useState(false)
    const getTasksCalendar = async (filters) => {
        try {
            setLoadingTasksCalendar(true)
            const response = await TaskService.getTasksCalendar(filters)
            setTasksCalendar(response.data)
        } catch (error) {
            console.log(error)

            setAlertSnackbar({
                open: true,
                message: "Error al obtener las tareas",
                severity: "error"
            })
        } finally {
            setLoadingTasksCalendar(false)
        }
    }


    const [selectedTaskPending, setSelectedTaskPending] = useState([])


    const handleSelectTaskPending = (task) => {
        if (selectedTaskPending.includes(task)) {
            setSelectedTaskPending(selectedTaskPending.filter(t => t.id !== task.id))
        } else {
            setSelectedTaskPending([...selectedTaskPending, task])
        }
    }


    const [loadingDeleteTask, setLoadingDeleteTask] = useState(false)
    const deleteTask = async (id) => {
        const confirm = await Swal.fire({
            title: '¿Está seguro de eliminar la tarea?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) return
        try {
            setLoadingDeleteTask(true)
            const response = await TaskService.deleteTask(id)
            setLoadingDeleteTask(false)
            setAlertSnackbar({
                open: true,
                message: "Tarea eliminada correctamente",
                severity: "success"
            })
            const startDate = moment().subtract(1, 'month').startOf('day')
            const endDate = moment().endOf('day')
            await getTasks({ startDate, endDate })
        } catch (error) {
            console.log(error)
            setLoadingDeleteTask(false)
            setAlertSnackbar({
                open: true,
                message: "Error al eliminar la tarea",
                severity: "error"
            })
        } finally {
            setLoadingDeleteTask(false)
        }
    }



    const [OtWithTaskPending, setOtWithTaskPending] = useState({
        assigned_to: null,
        time_execution: "000:10",
        task_list: [],
        datetime_created: "",
        extra_technical_support: []
    })


    const resetOtWithTaskPending = () => {
        setOtWithTaskPending({
            assigned_to: null,
            time_execution: "000:10",
            task_list: [],
            datetime_created: "",
            extra_technical_support: []
        })
    }

    //CREAR OT CON TAREAS SELECCIONADAS
    const [loadingCreateOTWithTasks, setLoadingCreateOTWithTasks] = useState(false)
    const createOTWithTasks = async () => {
        try {
            setLoadingCreateOTWithTasks(true)
            const response = await otService.createOTWithTasks(OtWithTaskPending)
            setAlertSnackbar({
                open: true,
                message: "OT creada correctamente",
                severity: "success"
            })
            resetOtWithTaskPending()
            navigate('/task/wo')
            setSelectedTaskPending([])
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Error al crear la OT",
                severity: "error"
            })
        }
        finally {
            setLoadingCreateOTWithTasks(false)
        }
    } 


    //GET TASK BY HASH CODE

    const [loadingTaskByHash, setLoadingTaskByHash] = useState(false)
    const [taskByHash, setTaskByHash] = useState(null)
    const [hash_code_task, setHashCodeTask] = useState({
        hash_code: null,
        task_scheduled_id: null,
    }) 
    const getTaskByHash = async (hash_code, taskScheduledId = null) => {
        try {
            setLoadingTaskByHash(true)
            const scheduledId = taskScheduledId ?? hash_code_task?.task_scheduled_id
            console.log(hash_code_task)
            const response = await TaskService.getTaskByHash(hash_code, ot.id, scheduledId)
            setTaskByHash(response.data)
            setLoadingTaskByHash(false) 

            await getOtCalculateCompleted(ot.hash_code)

        } catch (error) {
            console.log(error)
            setLoadingTaskByHash(false)
            const errorMessage = JSON.stringify(error.response.data)
            alert(errorMessage)
        }
    }


    //MANEJAR RESPUESTA DE SUBTAREAS
    /*
        Se modifica la logica de estas funciones, ya que no se actualizará la información directamente en la tabla task, sino que se hará en la tabla ot_task
    */
    const [subtaskResponseHash, setSubtaskResponseHash] = useState([])
    const [loadingUpdateSubtaskResponse, setLoadingUpdateSubtaskResponse] = useState(false)
    const updateSubtaskResponse = async () => {
        try {
            setLoadingUpdateSubtaskResponse(true)
            const data = {
                subtasks_responses: subtaskResponseHash,
                ot_id : ot.id,
                task_id : taskByHash.id,
                task_scheduled_id : hash_code_task.task_scheduled_id
            }
            const response = await TaskService.updateSubtaskResponse(data)
            setLoadingUpdateSubtaskResponse(false)
            setAlertSnackbar({
                open: true,
                message: "Respuesta actualizada correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)

        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Error al actualizar la respuesta",
                severity: "error"
            })
        } finally {
            setLoadingUpdateSubtaskResponse(false)
        }
    }


    // MANEJADOR DE INSUMOS DE LA TAREA - 
    const [isSelectResource, setIsSelectResource] = useState(false)
    const [resourceNotRegister, setResourceNotRegister] = useState(false)
    const [resourceSelected, setResourceSelected] = useState({
        code: "",
        name: "",
        quantity: 0,
        unit: "",
        name_new: "",
        not_register: false,
        confirmed: false
    })

    const resetResourceSelected = () => {
        setResourceSelected({
            code: "",
            name: "",
            quantity: 0,
            unit: "",
            name_new: "",
            not_register: false,
            confirmed: false
        })
        setIsSelectResource(false)
    }



    const handleAddResource = async () => {
        const existResource = taskByHash.resources.find(el => el.code === resourceSelected.code)

        if (existResource) {
            //Notificar que ya existe el codigo y se sumara la cantidad
            const alert = await Swal.fire({
                title: '¿Ya existe el insumo, desea sumar la cantidad?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                customClass: {
                    container: 'custom-swal2-container',
                    popup: 'custom-swal2-popup',
                    backdrop: 'custom-swal2-backdrop',
                }
            })
            if (!alert.isConfirmed) return

        } else {
            const alert = await Swal.fire({
                title: '¿Desea agregar el insumo?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                customClass: {
                    container: 'custom-swal2-container',
                    popup: 'custom-swal2-popup',
                    backdrop: 'custom-swal2-backdrop',
                }
            })
            if (!alert.isConfirmed) return
        }



        try {
            const data = {
                ...resourceSelected,
                task_hash_code: taskByHash.hash_code,
                not_register: resourceNotRegister,
                ot_id: ot.id,
                task_scheduled_id: hash_code_task.task_scheduled_id
            }
            const response = await TaskService.addResourceToTask(data)
            setAlertSnackbar({
                open: true,
                message: "Insumo agregado correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)
            resetResourceSelected()
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message:  error.response.data || "Error al agregar el insumo",
                severity: "error"
            })
        }


    }



    const handleDeleteAddedResource = async (index) => {
        const confirm = await Swal.fire({
            title: '¿Está seguro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        })
        if (confirm.isConfirmed) {
            const newResourceList = [...resourcesAdded]
            newResourceList.splice(index, 1)
            setResourcesAdded(newResourceList)
        }
    }


    // confirmar la cantidad de insumos usados
    const [loadingUpdateTaskResource, setLoadingUpdateTaskResource] = useState(false)
    const updateTaskResource = async (task_resource_id, quantity) => {
        try {
            const confirm = await Swal.fire({
                title: '¿Está seguro de confirmar la cantidad usada?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                customClass: {
                    container: 'custom-swal2-container',
                    popup: 'custom-swal2-popup',
                    backdrop: 'custom-swal2-backdrop',
                }
            })
            if (!confirm.isConfirmed) {
                return
            }
            setLoadingUpdateTaskResource(true)
            const data = {
                task_resource_id: task_resource_id,
                quantity: quantity,
                confirmed: true
            }
            const response = await TaskService.updateTaskResource(data)
            setAlertSnackbar({
                open: true,
                message: "Insumo actualizado correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Error al actualizar el insumo",
                severity: "error"
            })
        } finally {
            setLoadingUpdateTaskResource(false)
        }
    }


    //Iniciar la tarea
    const [loadingStartTask, setLoadingStartTask] = useState(false)
    const startTask = async () => {
        try {
            setLoadingStartTask(true)
            console.log(taskByHash)
            const data = {
                hash_code: taskByHash.hash_code,
                ot_id : ot.id,
                task_id : taskByHash.id,
                task_scheduled_id : hash_code_task.task_scheduled_id
            }
            const response = await TaskService.startTask(data)
            setLoadingStartTask(false)
            setAlertSnackbar({
                open: true,
                message: "Tarea iniciada correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)
        } catch (error) {
            console.log(error)
            setLoadingStartTask(false)
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Error al iniciar la tarea",
                severity: "error"
            })
        }
    }

    //Finalizar la tarea
    /*  
        Se modifica la logica de estas funciones, ya que no se actualizará la información directamente en la tabla task, sino que se hará en la tabla ot_task
    */
    const [loadingFinishTask, setLoadingFinishTask] = useState(false)
    const finishTask = async () => {
        const confirm = await Swal.fire({
            title: '¿Está seguro de finalizar la tarea?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) {
            return
        }
        try {
            setLoadingFinishTask(true)
            const data = {
                hash_code: taskByHash.hash_code,
                ot_id : ot.id,
                task_id : taskByHash.id,
                task_scheduled_id : hash_code_task.task_scheduled_id
            }
            const response = await TaskService.finishTask(data)
            setLoadingFinishTask(false)
            setAlertSnackbar({
                open: true,
                message: "Tarea finalizada correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)
            await getOtByHash(ot.hash_code)
        } catch (error) {
            console.log(error)
            setLoadingFinishTask(false)
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Error al finalizar la tarea",
                severity: "error"
            })
        }
        finally {
            setLoadingFinishTask(false)
        }
    }


    //Guardar el attach de la tarea
    /*
        Se modifica la logica de estas funciones, ya que no se actualizará la información directamente en la tabla task, sino que se hará en la tabla ot_task
    */
    const [loadingSaveTaskAttach, setLoadingSaveTaskAttach] = useState(false)

    const saveTaskAttach = async (data) => {
        try {
            setLoadingSaveTaskAttach(true)
            const formData = new FormData()
            formData.append('file', data.file[0])
            formData.append('type_attach', data.type_attach)
            formData.append('hash_code', taskByHash.hash_code)
            formData.append('ot_id', ot.id)
            formData.append('task_id', taskByHash.id)
            formData.append('task_scheduled_id', hash_code_task.task_scheduled_id)

            const response = await TaskService.saveTaskAttach(formData)
            setAlertSnackbar({
                open: true,
                message: "Attach guardado correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)
        } catch (error) {
            console.log(error)
            setLoadingSaveTaskAttach(false)
            setAlertSnackbar({
                open: true,
                message: "Error al guardar el attach",
                severity: "error"
            })
        }
        finally {
            setLoadingSaveTaskAttach(false)
        }
    }

    //Eliminar el attach de la tarea
    /*
        Se modifica la logica de estas funciones, ya que no se actualizará la información directamente en la tabla task, sino que se hará en la tabla ot_task
    */
    const [loadingDeleteTaskAttach, setLoadingDeleteTaskAttach] = useState(false)
    const deleteTaskAttach = async (id) => {

        const confirm = await Swal.fire({
            title: '¿Está seguro de eliminar el attach?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) {
            return
        }
        try {
            setLoadingDeleteTaskAttach(true)
            const data = {
                id: id,
            }
            const response = await TaskService.deleteTaskAttach(data)
            setLoadingDeleteTaskAttach(false)
            setAlertSnackbar({
                open: true,
                message: "Attach eliminado correctamente",
                severity: "success"
            })
            await getTaskByHash(taskByHash.hash_code)
        } catch (error) {
            console.log(error)
            setLoadingDeleteTaskAttach(false)
            setAlertSnackbar({
                open: true,
                message: "Error al eliminar el attach",
                severity: "error"
            })
        }
    }



    //Obtener las tareas de un mes en formato excel
    const [loadingTasksMonthExcel, setLoadingTasksMonthExcel] = useState(false)
    const getTasksMonthExcel = async () => {
        try {
            setLoadingTasksMonthExcel(true)
            
            // Preparar los filtros
            const filters = {
                ...filtersKanban,
                startDate: filtersKanban.startDate ? filtersKanban.startDate.format('YYYY-MM-DD') : null,
                endDate: filtersKanban.endDate ? filtersKanban.endDate.format('YYYY-MM-DD') : null,
                responsible: filtersKanban.responsible ? filtersKanban.responsible.id : null
            }

            const response = await TaskService.getTasksMonthExcel(filters)
            
            if (!response || !response.data) {
                throw new Error("Error al obtener las tareas")
            }

            // Crear URL del blob directamente desde la respuesta
            const url = window.URL.createObjectURL(response.data)

            // Crear elemento temporal para la descarga
            const link = document.createElement('a')
            link.href = url
            
            // Obtener el nombre del archivo del header Content-Disposition
            const contentDisposition = response.headers['content-disposition']
            let fileName = 'tareas_mes.xlsx'
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename=(.+)/)
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1].replace(/["']/g, '')
                }
            }
            
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            
            // Limpiar
            setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
            }, 100)

            setAlertSnackbar({
                open: true,
                message: "Tareas exportadas correctamente",
                severity: "success"
            })
        } catch (error) {
            console.error("Error al exportar tareas:", error)
            let errorMessage = "Error al exportar las tareas a Excel"
            
           
            
            setAlertSnackbar({
                open: true,
                message: errorMessage,
                severity: "error"
            })
        } finally {
            setLoadingTasksMonthExcel(false)
        }
    }




    return (
        <TaskContext.Provider value={{
            valueOtReview, setValueOtReview,
            task, setTask,
            conditions, setConditions,
            subtaskList, setSubtaskList,
            subtask, setSubtask,
            subtaskValue, setSubtaskValue,
            subtaskResponse, setSubtaskResponse,
            resetSubtask,
            indexSubtask, setIndexSubtask,
            validateSsomaDocument,
            loadingSsoma,
            ssomaResponse, setSsomaResponse,
            resetSsomaValidate,
            downloadSsomaDocument,
            loadingDownloadSsoma,
            resourceList, setResourceList,
            resource, setResource,
            resetResource,
            handleSaveResource,
            handleEditResource,
            handleDeleteResource,
            isUpdateResource,
            isNew, setIsNew,
            stepActive, setStepActive,
            handleStep, handleStepBack,
            loadingCreateTask,
            createTask,
            tasks,
            loadingTasks,
            getTasks,
            selectedTaskPending,
            handleSelectTaskPending,
            OtWithTaskPending, setOtWithTaskPending,
            createOTWithTasks,
            resetOtWithTaskPending,
            setSelectedTaskPending,
            loadingCreateOTWithTasks,
            getTaskByHash,
            loadingTaskByHash,
            taskByHash,
            setTaskByHash,
            hash_code_task,
            setHashCodeTask,
            subtaskResponseHash, setSubtaskResponseHash,
            updateSubtaskResponse,
            loadingUpdateSubtaskResponse,
            updateTaskResource,
            loadingUpdateTaskResource,
            resetTask,
            getSsomaDocument,
            loadingSsomaDocument,
            ssomaDocument,
            setSsomaDocument,
            saveSsomaCode,
            loadingStartTask,
            startTask,
            loadingFinishTask,
            finishTask,
            loadingSaveTaskAttach,
            saveTaskAttach,
            loadingDeleteTaskAttach,
            deleteTaskAttach,
            handleAddResource,
            handleDeleteAddedResource,
            resourceSelected,
            setResourceSelected,
            isSelectResource,
            setIsSelectResource,
            resetResourceSelected,
            resourceNotRegister,
            setResourceNotRegister,
            loadingDeleteTask,
            deleteTask,
            loadingUpdateTask,
            updateTask,
            isUpdateTask,
            setIsUpdateTask,
            filtersKanban,
            setFiltersKanban,
            tasksCalendar,
            loadingTasksCalendar,
            getTasksCalendar,
            loadingTasksMonthExcel,
            getTasksMonthExcel
        }}>
            {children}
        </TaskContext.Provider>
    )
}